import ExpandLessIcon from '@mui/icons-material/ExpandLess';

export default ExpandLessIcon;
